<template>
  <main-template>
    <template v-slot:main>

      <div class="page_top">
        <h1 class="title">
          <span>Оферта</span>
        </h1>
        <bread-crumbs
            :navigation-data="[
                {name: 'Главная', route: 'main'},
                {name: 'Оферта', route: 'offer'},
            ]">
        </bread-crumbs>
      </div>

      <div class="page_content" v-html="htmlData"></div>

    </template>
  </main-template>
</template>

<script>
// @ is an alias to /src
import MainTemplate from '@/components/MainTemplate.vue';
import BreadCrumbs from "@/components/share/BreadCrumbs";
import axios from "axios";



export default {
  name: 'OfferView',
  components: {
    BreadCrumbs,
    MainTemplate,
  },
  data() {
    return{
      htmlData: ""
    }
  },
  methods : {
    loadData : async function() {
      let res = await axios.get(window.api_url + "main/offer");

      this.htmlData = res.data;
    }
  },
  mounted() {
    this.loadData();
  }
}
</script>